/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
import React, { useState, useEffect, useRef } from 'react';
import { Box, Chip, Card, CardContent, Typography, Button, Tooltip, Backdrop, CircularProgress, Grid, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Paper, styled, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation} from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { makeStyles } from '@mui/styles';
import Stack from '@mui/material/Stack';
import CoffeeIcon from "@mui/icons-material/Coffee";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import InsightsIcon from "@mui/icons-material/Insights";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popover from '@mui/material/Popover';
import PsychologyIcon from "@mui/icons-material/Psychology";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useDispatch, useSelector } from 'react-redux';
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import LaunchIcon from '@mui/icons-material/Launch';
import Draggable from 'react-draggable';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import Calculator from '../../../components/Calculator';
import adminServices from '../../../services/adminServices';
import LottieLoading from '../../../components/LottieLoading';
import IconCalculator from '../../../assets/Images/calculator.png';
import TestComplete from '../../../assets/Images/TestComplete.png';
import { FromGeneralAssessmentView,ComingFrom } from '../../../store/reducer'
import AssessmentOverviewImage from '../../../assets/Images/Overview.png'

const categories = [
  { label: "Algebra", count: 5 },
  { label: "Advance Math", count: 4 },
  { label: "Problem Solving and Data Analysis", count: 7 },
  { label: "Geometry and Trigonometry", count: 5 },
  { label: "Standard English Conventions", count: 2 },
  { label: "Information and Ideas", count: 3 },
  { label: "Expression of Ideas", count: 2 },
  { label: "Craft & Structure", count: 3 },
];


function PaperComponent(props) {

  return (
    <Draggable handle=".drag-handle" bounds="body" cancel={'[class*="MuiDialogContent-root"]'}  >
      <Paper {...props} />
    </Draggable>
  );
}



export default function TopicTestsPage() {
  const location = useLocation();
  const dispatch = useDispatch()

  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state);
  const allassessmentdetails = useSelector((state) => state);
  

  const [selectedFilter, setSelectedFilter] = useState('');
  const [chapterList, setChapterList] = useState([])
  

  const [questions, setQuestions] = useState([])
  const [instructions, setInstructions] = useState(false)
  const [Chapterdetails, setChapterDetails] = useState('')
  
  const [tabIndex, setTabIndex] = useState(0);
  const classes = useStyles();

  const [testView, setTestView] = useState(false)
  const [isPaused, setIsPaused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openDrop, setOpendrop] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [overlayZIndex, setOverlayZIndex] = useState('none');
  const [markedForReview, setMarkedForReview] = useState({});
  const [parsedOptions, setParsedOptions] = useState([]);
  const [startTime, setStartTime] = useState('');
  const [questionTimes, setQuestionTimes] = useState([]);
  const [questionListAnchorEl, setQuestionListAnchorEl] = useState(null);
  const [time, setTime] = useState(0);
  const [gridLeft, setGridLeft] = useState(6);
  const [gridRight, setGridRight] = useState(6);
  const currentQuestion = questions && questions[currentIndex];
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [showModuleComplete, setShowModuleComplete] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [showCongratulationsModal, setShowCongratulationsModal] = useState(false);
 
  const open = Boolean(anchorEl);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };


  const getAccurateElapsed = () => {
    const now = Date.now();
    let elapsed = 0;

    if (backgroundStartRef.current) {
      elapsed += backgroundStartRef.current - lastUpdateRef.current;
      elapsed += now - backgroundStartRef.current;
      backgroundStartRef.current = null;
    } else {
      elapsed = now - lastUpdateRef.current;
    }

    lastUpdateRef.current = now;
    return Math.floor(elapsed / 1000);
  };

  const lastUpdateRef = useRef(Date.now());
  const backgroundStartRef = useRef(null);
  const timerRef = useRef(null);

  const updateTimer = () => {
    const elapsedSeconds = getAccurateElapsed();
    setTime(prev => {
      const newTime = prev - elapsedSeconds;

      if (newTime <= 0) {
        if (testView) {
          handlePostUserResult();

        }
        return 0;
      }
      return newTime;
    });
  };
  const startTimer = () => {
    if (time > 0) {
      timerRef.current = setInterval(updateTimer, 1000);
    }
  };


  useEffect(() => {
    lastUpdateRef.current = Date.now();
    startTimer();

    return () => {
      clearInterval(timerRef.current);
    };
  }, [isPaused, time]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(timerRef.current);
        backgroundStartRef.current = Date.now();
      } else {
        updateTimer();
        startTimer();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isPaused, testView]);


  const englishFilters = [
    "Standard English Conventions",
    "Craft & Structure",
    "Expression of Ideas",
    "Information and Ideas"
  ];
  const mathsFilters = [
    "Advance Math",
    "Algebra",
    "Geometry and Trigonometry",
    "Problem Solving and Data Analysis",
  ];
  let filteredCategories = categories;
  if (location.state === "English") {
    filteredCategories = categories.filter(cat =>
      englishFilters.some(f => cat.label.includes(f))
    );
  } else if (location.state === "Maths") {
    filteredCategories = categories.filter(cat =>
      mathsFilters.some(f => cat.label.includes(f))
    );
  }

  useEffect(() => {
    if (filteredCategories && filteredCategories.length > 0 && !selectedFilter) {
      setSelectedFilter(filteredCategories[0].label);
    }
  }, [filteredCategories, selectedFilter]);

  useEffect(() => {
    if (filteredCategories && filteredCategories.length > 0 && chapterList.length > 0) {
      if (tabIndex >= filteredCategories.length) {
        setTabIndex(0);
      }
    }
  }, [chapterList, filteredCategories.length]);


  useEffect(() => {
    if (instructions === true && testView === true) {
      dispatch(FromGeneralAssessmentView(true));
    } else {
      dispatch(FromGeneralAssessmentView(false));
    }
  }, [instructions, testView, dispatch]);


  const handleCalculatorOpen = () => setCalculatorOpen(true);
  const handleCalculatorClose = () => setCalculatorOpen(false);
  const formatTimeTimer = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleOpenQuestionList = (event) => {
    setQuestionListAnchorEl(event.currentTarget);
    setOverlayZIndex('block');
  };

  const handleCloseQuestionList = () => {
    setQuestionListAnchorEl(null);
    setOverlayZIndex('none');
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOverlayZIndex('none');
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOverlayZIndex('block');
  };

  const handleNavigation = () => {
    const comingfrom = "Chapter"
    if(allassessmentdetails?.comingfrom === 'Dashboard'){
      if (userInfo?.role === 'AUTH_USER') {
        navigate('/app/course', { state: comingfrom });
      }
      else {
        dispatch(ComingFrom('Assessments'));
        navigate('/auth/subscribe', { state: comingfrom });
      }
    }
    else{
      if (userInfo?.role === 'AUTH_USER') {
        navigate('/app/course', { state: comingfrom });
      }
      else {
        navigate('/auth/subscribe', { state: comingfrom });
      }
    }
   
  }

  const handleGridLeft = () => {

    if (gridLeft === 7 && gridRight === 5) {
      setGridLeft(6);
      setGridRight(6)
    }
    else {
      setGridLeft(7);
      setGridRight(5)
    }
  }
  const handleGridRight = () => {
    if (gridLeft === 5 && gridRight === 7) {
      setGridLeft(6);
      setGridRight(6)
    }
    else {
      setGridLeft(5);
      setGridRight(7)
    }

  }

  const handleSubmit = async () => {
    setOpenConfirmDialog(true);

  };

  useEffect(() => {
    getChapterList(location.state, userInfo?.id)
  }, [location.state])

  const getChapterList = async (type, userId) => {
    setIsLoading(true);
    try {
      const result = await adminServices.getSatChapterList(type, userId);
      if (result.ok) {
        setChapterList(result.data)
      }
    } catch (error) {
      console.error('Error fetching chapter list:', error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleStartTest = (chapterid) => {

    getStartSATChapterAssessment(chapterid?.related_chapter_id, location.state)
    setChapterDetails(chapterid)
    setInstructions(true)
  }

  const handleNavigateTest = (data,chapterid) => {
    if(data?.subscriptionplanid){
       navigate('/auth/ChapterLevelSimulation', {
        state: {
          chapterid,
          type: location.state
        }
      });
    }
    else{   
      const comingfrom = 'chapterview'
      navigate("/auth/PrePaymentPage", { state:{ ...data, comingfrom}})
    }
  }

  const handleQuestionSelect = (index) => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;

    setQuestionTimes((prev) => ({
      ...prev,
      [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
    }));

    setStartTime(Date.now());
    setCurrentIndex(index);
    handleCloseQuestionList();
  };


  const handleBookmarkTrue = (index) => {
    setMarkedForReview((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };

  const handleBookmarkFalse = (index) => {
    setMarkedForReview((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };

  const onBack = () => {
    setTestView(false);
    setInstructions(false);
    setCurrentIndex(0);
    setSelectedAnswers([]);
    setQuestionTimes([]);
    setMarkedForReview({});
    setCorrectAnswer([]);
    setTime(0);
    setIsPaused(false);
    setShowModuleComplete(false);
    setCalculatorOpen(false);
  };


  const onStartTest = () => {
    setTime(1800)
    setTestView(true)
  }

  const getStartSATChapterAssessment = async (chapterid, type) => {
    setIsLoading(true);
    try {
      const result = await adminServices.getStartSATChapterAssessment(chapterid, type);
      if (result.ok) {
        setQuestions(result.data);
      }
    } catch (error) {
      console.error('Error starting assessment:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (currentQuestion && currentQuestion.options) {
      try {
        const parsed = typeof currentQuestion.options === 'string'
          ? JSON.parse(currentQuestion.options)
          : currentQuestion.options;

        setParsedOptions(parsed.mcqOptions);
      } catch (error) {
        console.error("Failed to parse options:", error);
        setParsedOptions([]);
      }
    }
  }, [currentQuestion]);

  const handleNext = () => {
    const endTime = Date.now();
    const timeSpent = (endTime - startTime) / 1000;
    const currentQuestion = questions[currentIndex];
    setStartTime(Date.now());
    setQuestionTimes((prev) => ({
      ...prev,
      [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
    }));


    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };


  const handleBack = () => {
    if (currentIndex > 0) {
      const endTime = Date.now();
      const timeSpent = (endTime - startTime) / 1000;

      setQuestionTimes((prev) => ({
        ...prev,
        [currentIndex]: (prev[currentIndex] || 0) + timeSpent,
      }));

      setStartTime(Date.now());
      setCurrentIndex(currentIndex - 1);
    }
  };




  const handleOptionSelect = (option, index) => {
    let parsedData;

    try {
      parsedData = typeof currentQuestion?.options === 'string'
        ? JSON.parse(currentQuestion.options)
        : currentQuestion.options;

      const correctAnswers = parsedData.correctAnswer || [];
      const isCorrect = correctAnswers[index];
      const stringifiedIsCorrect = JSON.stringify(isCorrect);

      setCorrectAnswer((prev) => ({
        ...prev,
        [currentIndex]: stringifiedIsCorrect === "false" || stringifiedIsCorrect === false
          ? "incorrect"
          : "correct",
      }));

      setSelectedAnswers((prev) => ({
        ...prev,
        [currentIndex]: option,
      }));
    } catch (error) {
      setCorrectAnswer((prev) => ({
        ...prev,
        [currentIndex]: "incorrect",
      }));
      setSelectedAnswers((prev) => ({
        ...prev,
        [currentIndex]: option,
      }));
    }
  };

  const handleClearResponse = () => {
    setSelectedAnswers((prev) => {
      const newAnswers = { ...prev };
      delete newAnswers[currentIndex];
      return newAnswers;
    });

    setCorrectAnswer((prev) => {
      const newCorrectAnswers = { ...prev };
      delete newCorrectAnswers[currentIndex];
      return newCorrectAnswers;
    });
  };


  const handlePostUserResult = async () => {
    setOpenConfirmDialog(false);
    setIsLoading(true);

    const totalTimeTaken = Object.values(questionTimes).reduce((acc, time) => acc + time, 0);
    const formattedSelectedAnswers = questions && questions?.length > 0 && questions.map((question, index) => ({
      questionId: question.id,
      index,
      selectedAnswer: selectedAnswers[index] || null,
      timeTaken: questionTimes[index] || 0,
      response_recorded: correctAnswer[index] || null,
      multiplier: question?.cognitive_skill_id
    }));

    const body = {
      type: location.state,
      assessment_id: Chapterdetails?.id,
      user_id: userInfo?.id,
      user_result: formattedSelectedAnswers,
      date_started: getCurrentTime(),
      date_completed: getCurrentTime(),
      difference_date: totalTimeTaken,
      attemptCount: 0,
      submodules: Chapterdetails?.chapter_description,
      section: location.state,
      last: location.state,
      name: Chapterdetails?.chapter_description,
      description: Chapterdetails?.chapter_description,
      SATtype: 'Chapter_Level',
      level: 'medium',
      subscribedDate: ''
    };

    const result = await adminServices.postChapterLevelSATResult(body);
    setMarkedForReview({});

    if (result.ok) {
      setShowCongratulationsModal(true);
      setTimeout(() => {
        setIsLoading(false);
        setShowCongratulationsModal(false);

        getChapterList(location.state, userInfo?.id)


        setTestView(false);
        setInstructions(false);


        setCalculatorOpen(false);
        setShowModuleComplete(false);
        setSelectedAnswers([]);
        setStartTime('');
        setQuestionTimes([]);
        setTime(0);
        setCorrectAnswer([]);
        setCurrentIndex(0);
      }, 2000);
    }
  }

  const handleCloseCongratulations = () => {
    setShowCongratulationsModal(false);
  };

  const handleFilterSelect = (filterLabel) => {
    setSelectedFilter(filterLabel);
    setIsLoading(false)
  };

  const getFilteredChapters = () => {
    if (!filteredCategories || filteredCategories.length === 0 || tabIndex >= filteredCategories.length) {
      return [];
    }

    const selectedCategory = filteredCategories[tabIndex];
    if (!selectedCategory || !chapterList) return [];

    return chapterList.filter(chapter => {
      if (!chapter.chapter_description) return false;

      const description = chapter?.chapter_units;
      switch (selectedCategory.label) {
        case 'Algebra':
          return description.includes('Algebra');
        case 'Advance Math':
        case 'Advanced Math':
          return description.includes('Advanced Math') || description.includes('Advance Math');
        case 'Problem Solving and Data Analysis':
          return description.includes('Problem Solving and Data Analysis');
        case 'Geometry and Trigonometry':
          return description.includes('Geometry and Trigonometry');

        case 'Standard English Conventions':
          return description.includes('Standard English');
        case 'Information and Ideas':
          return description.includes('Information and Ideas');
        case 'Expression of Ideas':
          return description.includes('Expression of Ideas');
        case 'Craft & Structure':
          return description.includes('Craft and Structure') || description.includes('Craft & Structure');

        default:
          return false;
      }
    });
  };


  const displayedChapters = getFilteredChapters();
  const filteredChapters =
  allassessmentdetails?.comingfrom === 'Dashboard'
    ? displayedChapters?.filter(
        test => test?.ispaid && test?.subscription_status !== 'DELETED'
      )
    : displayedChapters;



  const postAssessmentSubscribtionDetails = async (data) => {
    navigate("/auth/PrePaymentPage", { state: data })
    // const courseId = data?.id;
    // const planid = data?.subscriptionplanid;

    // let impactClickId = '';
    // try {
    //   impactClickId = await helper.getClickId();
    // } catch (error) {
    //   console.error(error);
    //   impactClickId = '';
    // }

    // const payload = {
    //   userId: userInfo?.id,
    //   courseId,
    //   planId: planid,
    //   currencyType: currency,
    //   frequency: parseInt(1),
    //   impactClickId,
    //   type: 'assessment'
    // };

    // try {
    //   const res = await trialAndStripeSubscriptionService.createAssessmentSubscription(JSON.stringify(payload));

    //   if (res.status === 303) {

    //     window.location = res.data.paymentUrl;
    //   } else {
    //     if (res?.data?.message) {
    //       dispatch(openSnackbar(res.data.message));
    //     } else {
    //       dispatch(openSnackbar('Failed to Subscribe, Please try again.'));
    //     }
    //   }
    // } catch (error) {
    //   console.log(error);
    // }

  };


  return (
    <Box p={3} sx={{ padding: '0 30px !important' }}>
      {isLoading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(255, 255, 255, 0.9)'
          }}
          open
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress color="primary" size={60} thickness={4} />
            <Typography variant="h6" sx={{ mt: 2, color: 'text.primary' }}>
              Loading Assessment...
            </Typography>
          </Box>
        </Backdrop>
      )}
      {instructions === false && <>
        <Box display="flex" gap={1} flexWrap="wrap" mt={12} >
          <Box sx={{
            //  marginLeft: '15px'
            width: '93%'
          }}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ padding: '0 15px  10px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} separator=">" >
              <Typography style={{ cursor: 'pointer', textDecoration: 'none', border: 'none', background: 'none', color: '#7a7a7a !important', fontWeight: '500 ' }} onClick={handleNavigation}>SAT Test Prep</Typography>
              <Typography style={{  textDecoration: 'none', border: 'none', background: 'none', color: '#0000ee' , fontWeight: '600 '}} >
                {location.state === "Maths" ? "Math Chapter Test" : "Reading and Writing Chapter Test"}
              </Typography>
            </Breadcrumbs>
          </Box>

          <Box className={classes.greetingCard}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', }}>
              <Box>
                <Typography variant="h5" sx={{ marginBottom: '10px', fontWeight: 900, color: '#000000ff' }}>
                  <strong>Welcome, {userInfo?.firstName ? userInfo.firstName.charAt(0).toUpperCase() + userInfo.firstName.slice(1).toLowerCase() : 'Student'}!</strong>
                </Typography>
                <Typography variant="h6" sx={{ fontSize: '17px', fontWeight: 500, color: '#000000ff' }}>
                  Practice and get better scores with our assessments 
                </Typography>
              </Box>
              <Box sx={{ width: "150px", position: 'relative', height: "75px" }}>
                <img
                  style={{
                    scale: '2.1',
                    position: 'absolute',
                    width: "148px",
                    bottom: '8px',
                    transform: 'scaleX(1)',
                  }}
                  src={AssessmentOverviewImage}
                  alt="Assessment Overview"
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "auto"
            }}
          >
            <Typography variant="h5" style={{ fontWeight: "900", margin: '4px 0', padding: '4px 4px' }} ><strong>{location.state === "Maths" ? "Math Chapter Test" : "Reading & Writing Chapter Test"}</strong></Typography>
            <Stack direction="row" spacing={2} style={{ paddingLeft: '18px', display: 'flex', justifyContent: 'space-between' }} />
            {/* <Box style={{ display: 'flex' }}> */}
            {/* <Item style={{ lineHeight: 1.1, padding: '4px 8px' }}>No. of Attempts Left: {assessmentDetails?.attempts?.length && assessmentDetails?.attempts !== null ? 5 - assessmentDetails?.attempts?.length : 5}</Item> */}
            {/* <Item style={{ lineHeight: 1.1, padding: '4px 8px', marginLeft: '8px' }}>SAT</Item> */}
            {/* </Box> */}
          </Box>


          {filteredCategories && filteredCategories.length > 0 && (
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons={false}
              aria-label="Category Tabs"
              indicatorColor="primary"
              textColor="primary"
              sx={{
                borderBottom: 0,
                marginBottom: '5px',
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiTabs-scroller': {
                  overflowX: 'auto !important',
                  overflowY: 'hidden',
                  scrollbarWidth: 'thin',      
                  '&::-webkit-scrollbar': {
                    height: 6,                   
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#b5b5b5',
                    borderRadius: 4,
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f0f0f0',
                  },
                },
                '& .MuiTabs-flexContainer': {
                  width: 'max-content',
                  display: 'flex',
                },
              }}

            >
              {filteredCategories.map((cat, i) => (
                <Tab
                  key={i}
                  label={`${cat.label}`}
                  sx={{
                    textTransform: 'none',
                    fontWeight: tabIndex === i ? 'bold' : 'normal',
                    minHeight: '36px',
                    padding: '6px 12px',
                    margin: '0 2px',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    color: tabIndex === i ? '#0D2C60' : 'rgba(0, 0, 0, 0.6)',
                    border: 'none',
                    borderBottom: tabIndex === i ? '3px solid #0D2C60' : '3px solid transparent',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(45, 107, 250, 0.04)',
                      color: '#0D2C60',
                    },
                    '&.Mui-selected': {
                      color: '#0D2C60 !important',
                      borderBottom: '3px solid #0D2C60 !important',
                      backgroundColor: 'rgba(45, 107, 250, 0.04)',
                      borderRadius: '4px'
                    }
                  }}
                />
              ))}
            </Tabs>
          )}


        </Box>
        <Grid container spacing={3} mb={3}>
          {filteredChapters?.length > 0 ? filteredChapters.map((test, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    {test?.ispaid && test?.subscription_status !=='DELETED' ?
                      <Chip label="Purchased" color="secondary" size="small" sx={{ borderRadius: '8px', backgroundColor: '#32D74B', color: 'white', fontSize: '12px' }} />
                      : <Chip label="Premium" color="secondary" size="small" sx={{ borderRadius: '8px', backgroundColor: '#B3254D', color: 'white', fontSize: '12px' }} />
                    }
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        borderRadius: '4px',
                        color: '#3B82F6',
                        borderColor:  '#3B82F6',
                        background:  'rgba(255, 255, 255, 1)',
                        fontSize: '12px',
                        padding: '4px 12px',
                        "&:hover": test?.ispaid && test?.subscription_status !=='DELETED'
                          ? test?.attempt_count === 1
                            ? {
                              backgroundColor: "#3B82F6",
                              color: "#fff",
                              borderColor: "#3B82F6",}
                            : {
                              backgroundColor: "#fff",
                              color: "#3B82F6",
                              borderColor: "#3B82F6",
                            }
                          : {
                            backgroundColor: "#3B82F6",
                            color: "#fff",
                            borderColor: "#3B82F6",
                          },
                        cursor: test?.ispaid && test?.subscription_status !=='DELETED' && test?.attempt_count === 1 ? 'pointer' : 'pointer',
                      }}
                     
                      onClick={() => handleNavigateTest(test,test?.related_chapter_id)}
                    >
                     
                        View More
                    </Button>

                  
                  </Box>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, fontSize: '16px' }}>{test.chapter_description}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#666' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><HelpOutlineIcon sx={{ fontSize: '16px' }} /><Typography variant="body2">25 Questions</Typography></Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><AccessTimeIcon sx={{ fontSize: '16px' }} /><Typography variant="body2">30 Mins</Typography></Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )) : 
          ( allassessmentdetails?.comingfrom === 'Dashboard' ?
            <Grid item xs={12}><Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>No Subscription Found</Typography></Grid>
            :
          <Grid item xs={12}><Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>No chapters available for the selected category.</Typography></Grid>
        
        )}
        </Grid>

      </>}

      {instructions === true && testView === false && <>
        <Box display="flex" gap={1} flexWrap="wrap" mb={4} mt={10}>
          <Box className="practiceTimeInstructions" sx={{ mx: "auto", p: 2, textAlign: "center" }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              {`${Chapterdetails?.chapter_description && Chapterdetails?.chapter_description} Test`}
            </Typography>


            <Card variant="outlined" sx={{ textAlign: "left" }}>
              <CardContent>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <HourglassTopIcon className='newiconDesign' />
                  <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Timings"}</Typography>
                </Box>
                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                  <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                    <li>{"The"} <strong>{`${Chapterdetails?.chapter_description} `}</strong> {"Chapter Test is"} <strong>{"30 minutes"}</strong> {"long."}</li>
                    <li>{"It contains 25 questions."}</li>
                    <li>{"You can pause at any time, but the timer will not reset once started."}</li>
                  </ul>
                </Typography>
                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                  <CoffeeIcon className='newiconDesign' />
                  <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Breaks"}</Typography>
                </Box>
                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                  <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                    <li>{"Chapter tests are short and do not include breaks."}</li>
                    {/* <li>{"There is only one test."}</li> */}
                  </ul>
                </Typography>
                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                  <InsightsIcon className='newiconDesign' />
                  <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Scores & Analytics"}</Typography>
                </Box>
                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                  <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                    <li>{"Your score will be available immediately after completing the test."}</li>
                    <li>{"Analytics will highlight your performance for this chapter, helping you identify strengths and areas for improvement."}</li>
                  </ul>
                </Typography>
                <Box style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                  <PsychologyIcon className='newiconDesign' />
                  <Typography style={{ display: 'inline', marginTop: '10px' }} variant="h6" className='topicHeading' fontWeight="bold">{"Best Practice"}</Typography>
                </Box>
                <Typography style={{ paddingLeft: '50px' }} variant="body2">
                  <ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
                    <li>{"Treat this chapter test as a focused SAT practice session."}</li>
                    <li>{"Choose a quiet space and aim to finish in one sitting to simulate real test conditions."}</li>
                  </ul>
                </Typography>
              </CardContent>
            </Card>
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, marginBottom: { xs: '20px !important', sm: '20px !important', md: '0px !important' } }}>
              <Button variant="outlined" sx={{
                backgroundColor: '#fff',
                color: '#3F3F3F',
                borderWidth: '1.5px',
                borderColor: '#3F3F3F !important',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#3F3F3F',
                  color: '#fff'
                }
              }}
                onClick={onBack}> <ArrowBackIcon />{"Back"}</Button>
              <Button variant="contained" style={{ backgroundColor: '#225AD6', color: '#fff', borderRadius: '6px' }}
                onClick={onStartTest}>{"Start Test"}<ArrowForwardIcon /></Button>
            </Box>
          </Box>
        </Box>
      </>}

      {instructions === true && testView === true && <>
        <Box display="flex" gap={0} flexWrap="wrap" mb={0} marginTop="75px">
          <>
            <Box sx={{ width: '100%', backgroundColor: "#d2daff" }}>
              {(isLoading) ? <br /> :
                <Box id="topicHead" sx={{ display: 'flex', flexDirection: { md: 'row', sm: "column", xs: "column" }, justifyContent: 'space-between', width: '100%', maxHeight: '60px' }}>
                  <Box sx={{}}>
                    {location?.state === 'English' ? (
                      <>
                        <Typography
                          sx={{
                            padding: '10px 0px 0px 40px',
                            fontSize: { xs: '20px', md: '22px' },
                            fontWeight: { xs: 600, md: 700 },
                            paddingTop: '0px', position: 'relative', top: "3px"
                          }}
                          variant="h5"
                        >
                          Reading and Writing
                        </Typography>

                        <Dialog
                          open={openDrop}
                          onClose={() => setOpendrop(false)}
                          fullWidth
                          maxWidth="sm"
                          className='dialogWithArrow'
                          PaperProps={{
                            sx: {
                              zIndex: 1105,
                              position: 'absolute',
                              left: '1vh',
                              top: '160px',
                              m: 0
                            },

                          }}
                        >

                          <DialogContent>
                            <Typography>
                              {"The essay gives you an opportunity to show how effectively you can read and comprehend a passage and write an essay analyzing the passage. In your essay, you should demonstrate that you have read the passage carefully, present a clear and logical analysis, and use language precisely."}
                            </Typography>
                            <Button
                              onClick={() => setOpendrop(false)}
                              variant="contained"
                              sx={{
                                background: "#ff9800", color: "#fff", borderRadius: "5px",
                                float: 'right',
                                marginTop: '20px',

                                "&:hover": {
                                  background: "#d3d3d3",
                                  color: "#444"
                                }
                              }}
                            >
                              {"Close"}
                            </Button>
                          </DialogContent>
                        </Dialog>

                      </>
                    ) :
                      <Typography
                        sx={{
                          padding: '0px 0px 0px 40px',
                          fontSize: { xs: '20px', md: '22px' },
                          fontWeight: { xs: 600, md: 700 },
                          paddingTop: '0px', position: 'relative', top: "3px"
                        }}
                        variant="h6">{/* {"Section 2: Math"} */}
                        Math
                        {/* {(details?.assessment_type === null || details?.assessment_type === '') ? "Section 2: Math" : "Math"} */}
                      </Typography>}
                    <Typography
                      variant="text"
                      sx={{
                        textTransform: "none",
                        fontSize: "17px",
                        float: 'left',
                        top: '-7px',
                        cursor: 'pointer',
                        position: 'relative',
                        color: '#000',
                        fontWeight: '500',
                        paddingLeft: '40px'
                      }}
                      onClick={handleClick}>
                      {"Directions"}<KeyboardArrowDownIcon style={{ position: 'relative', color: '#4a4a4a', fontSize: '24px' }} />
                    </Typography>
                    <Popover

                      //   id={id}
                      open={open}
                      PaperProps={{
                        sx: {
                          width: location?.state === 'English' ? 'auto' : '75vw',
                          maxWidth: '90vw',
                        },
                      }}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',

                      }}
                    >
                      {location?.state === 'English' ? (
                        <Typography sx={{ p: 2, maxWidth: '550px', }}> The questions in this section address several important reading and writing skills. Each question includes one or more passages, which may include a table or graph. Read each passage and question carefully and then choose the best answer to the question based on the passage(s). All questions in this section are multiple-choice with four answer choices. Each question has a single best answer.
                        </Typography>) : (
                        <Typography sx={{ p: 2 }}>
                          The questions in this module will test all levels of your math skills.
                          <br /><br />
                          The use of a simple calculator is permitted for all questions. You can click on the calculator icon to start using the calculator.
                          <br /><br />
                          If the question does not specify, you should assume:
                          <br />
                          &nbsp;&nbsp;&bull; All variables and expressions represent real numbers.
                          <br />
                          &nbsp;&nbsp;&bull; The figures provided are drawn to scale.
                          <br />
                          &nbsp;&nbsp;&bull; All figures lie in a plane.
                          <br />
                          &nbsp;&nbsp;&bull; The domain of a given function "f" is the set of all real numbers "x" for which "f(x)" is a real number.
                          <br /><br />
                          Every question in this module is a multiple-choice based question and has a single correct answer.
                          You are expected to solve each problem and choose the correct one.
                          <br /><br />
                          The timer is set on the server after your test starts, and the test will be auto submitted after the timer runs out.
                          You can submit the test within the test if you are satisfied with your answers.
                        </Typography>)}
                      <Button style={{
                        float: 'right', marginRight: '20px',
                        marginBottom: '10px',
                        border: '1px solid'
                      }} onClick={handleClose}>Close</Button>
                    </Popover>

                  </Box>
                  <Box sx={{ maxHeight: { md: '60px', sm: '70px' }, width: { md: '20%', sm: '99vw', justifyItems: 'center' } }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", position: 'relative', top: '5px' }}>{formatTimeTimer(time)}</Typography>
                    {!chapterList?.length > 0 &&
                      <Typography variant="h6" sx={{ padding: '3px 12px', fontWeight: "bold" }}>{"Module -"} {"submodule"}</Typography>
                    }

                  </Box>
                  <Box sx={{ visibility: { md: 'visible', sm: 'visible' }, alignContent: 'center', display: { sm: "block" }, width: { md: '20%', sm: '99vw' } }}>

                    {location?.state === "Maths" &&
                      <Tooltip title="Calculator">
                        <Button variant='outlined' id='CalculatorBtn' onClick={handleCalculatorOpen}
                          sx={{
                            borderRadius: '4px', float: 'right', color: '#1976d2', fontSize: '16px', marginRight: '5px', padding: '3px 12px',
                            borderColor: '#1976d2', '&:hover': {
                              borderRadius: '4px',
                              borderColor: '#1976d2', backgroundColor: 'rgba(25, 118, 210, 0.04)'
                            }
                          }}>


                          <img alt='calculator' src={IconCalculator} style={{ width: '27px', height: '27px', marginLeft: '4px' }} />

                        </Button>
                      </Tooltip>}

                  </Box>
                </Box>}
              {location?.state === 'English' ?
                <Grid id="QuestionPanel" container sx={{ flex: 1, padding: '0px 8px' }}>
                  {isLoading ?
                    <Grid sx={{
                      padding: 1, backgroundColor: "#ffffff",
                      paddingTop: '200px',
                      width: '100%',
                      paddingRight: '0px',
                      marginTop: '60px',
                      paddingleft: '0px',
                      height: 'Calc(100vh - 225px)',
                      overflowX: 'hidden',
                      overflowY: 'auto',
                    }}>

                      <LottieLoading loading={isLoading} />
                      {showModuleComplete && (
                        <Box
                          sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                            padding: '20px',
                            textAlign: 'center'
                          }}
                        >
                          <Typography variant="h4" sx={{ color: '#909bd7', marginBottom: 2, fontWeight: '500' }}>
                            This Module Is Over
                          </Typography>
                          <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: '500' }}>
                            All your work has been saved
                          </Typography>
                          <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                            You'll move on automatically in just a moment.
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'red' }}>
                            Do not refresh this page or quit the app.
                          </Typography>
                        </Box>
                      )}
                    </Grid> :
                    <>
                      <Grid item sm={12} md={gridLeft} id="gridLeftSection" sx={{
                        padding: 1, backgroundColor: "#ffffff", borderRight: "5px solid #7d7d7d",
                        paddingTop: '35px',
                        paddingRight: '50px',
                        paddingLeft: '35px',
                        position: 'relative',
                        paddingleft: '50px',
                        height: 'Calc(100vh - 200px)',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                      }}>

                        <Typography dangerouslySetInnerHTML={{ __html: currentQuestion?.passage }}
                          style={{ userSelect: "none" }}
                          onCopy={(e) => e.preventDefault()}
                          onContextMenu={(e) => e.preventDefault()} />

                        <Box id="LaunchIcon" sx={{
                          boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: '40px',
                          width: '40px',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                          marginBottom: '10px',
                          color: '#adadad',
                          top: '8px',
                          right: '14px',
                          position: 'absolute'
                        }} onClick={handleGridLeft}>
                          <LaunchIcon style={{ scale: '1.1' }} />
                        </Box>

                      </Grid>
                      <Grid item sm={12} md={gridRight} sx={{
                        padding: 1, backgroundColor: "#f9f9f9",
                        paddingTop: '8px',
                        paddingRight: '39px',
                        position: 'relative',
                        paddingLeft: '0px',
                        height: 'Calc(100vh - 200px)',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        display: 'flex',
                      }}>
                        <Box id="LaunchIconRight" onClick={handleGridRight} sx={{
                          boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px', height: '40px',
                          minWidth: '40px',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                          marginBottom: '10px',
                          color: '#adadad',
                          top: '0px',
                          left: '14px',
                          position: 'sticky'
                        }}>
                          <LaunchIcon style={{ transform: 'rotate(270deg)', scale: '1.1' }} />
                        </Box>
                        {currentQuestion && (
                          <Box className="assessmentQuestionPanel" sx={{ paddingLeft: "25px !important", paddingTop: "25px !important", flex: '2' }}>

                            <Box
                              sx={{
                                padding: '4px',
                                backgroundColor: "#f0f0f0",
                                borderRadius: '2px',
                                textAlign: "center",
                                borderBottom: '3px dashed #000000c9',
                                paddingLeft: { sx: 0, md: "50px" }
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 1,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "inline-block",
                                    padding: "4px 10px !important",
                                    backgroundColor: "black",
                                    borderRadius: "2px",
                                    marginBottom: 0,
                                  }}
                                >
                                  <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "white" }}>
                                    {currentIndex + 1}
                                  </Typography>
                                </Box>

                                <Button
                                  onClick={() => {
                                    if (markedForReview[currentIndex]) {
                                      handleBookmarkFalse(currentIndex);
                                    } else {
                                      handleBookmarkTrue(currentIndex);
                                    }
                                  }}
                                  className="MarkBtn"
                                  sx={{
                                    minWidth: "auto",
                                    color: '#1976d2',
                                  }}
                                >
                                  {markedForReview[currentIndex] ? (
                                    <BookmarkIcon color="#1976d2" />
                                  ) : (
                                    <BookmarkBorderIcon color="#1976d2" />
                                  )}
                                  {markedForReview[currentIndex] ? 'Marked for Review' : 'Mark for Review'}
                                </Button>
                                <Button onClick={() => handleClearResponse()} sx={{ minWidth: "auto", color: '#1976d2', lineHeight: '1.2', }} className="MarkBtn">
                                  Clear response</Button>
                              </Box>
                            </Box>
                            <Typography style={{ justifySelf: 'start', userSelect: "none", margin: "10px 0" }}
                              dangerouslySetInnerHTML={{ __html: currentQuestion?.question_text }}

                              onCopy={(e) => e.preventDefault()}
                              onContextMenu={(e) => e.preventDefault()}
                            />
                            {parsedOptions && parsedOptions?.map((option, index) => (
                              <Button
                                key={index}
                                variant="contained"
                                fullWidth
                                sx={{
                                  marginTop: 1,
                                  fontWeight: "400",
                                  backgroundColor: "white",
                                  color: "black",
                                  lineHeight: '1.2',
                                  justifyContent: 'start',
                                  borderRadius: '4px',
                                  padding: '17px 20px',
                                  border: selectedAnswers[currentIndex] === option ? "3px solid #4caf50" : "1px solid #ccc",
                                  "&:hover": {
                                    backgroundColor: "#f1f1f1",
                                  }
                                }}
                                onClick={() => handleOptionSelect(option, index)}
                              >
                                <span style={{
                                  border: '1px solid #aaa',
                                  borderRadius: '50%',
                                  fontWeight: '400',
                                  padding: '7px',
                                  height: '23px',
                                  width: '23px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginRight: '15px',
                                }}>{String.fromCharCode(97 + index)}</span>
                                <span dangerouslySetInnerHTML={{ __html: option }} />

                              </Button>
                            ))}
                          </Box>
                        )}
                      </Grid> </>}
                </Grid> :
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: location?.state === 'English' ? 'Calc(100vh - 208px)' : 'Calc(100vh - 200px)', textAlign: "center", alignItems: 'baseline' }}
                >
                  {
                    isLoading ?
                      <Grid sx={{
                        padding: 1, backgroundColor: "#ffffff",
                        paddingTop: '200px',
                        width: '100%',
                        paddingRight: '0px',
                        marginTop: '60px',
                        paddingleft: '0px',
                        height: 'Calc(100vh - 180px)',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                      }}>
                        <LottieLoading loading={isLoading} />
                        {showModuleComplete && (
                          <Box
                            sx={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: 'rgba(255, 255, 255, 0.95)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              zIndex: 9999,
                              padding: '20px',
                              textAlign: 'center'
                            }}
                          >
                            <Typography variant="h4" sx={{ color: '#909bd7', marginBottom: 2, fontWeight: '500' }}>
                              This Module Is Over
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: '500' }}>
                              All your work has been saved
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                              You'll move on automatically in just a moment.
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'red' }}>
                              Do not refresh this page or quit the app.
                            </Typography>
                          </Box>
                        )}
                      </Grid> :
                      currentQuestion && (
                        <Box
                          sx={{
                            width: {
                              xs: "90%", sm: "80%", md: "70%", lg: "68%", xl: "85%"
                            },
                            marginTop: '0px',
                            backgroundColor: "#e9f0fa",
                            borderRadius: 1,
                            textAlign: "center",
                            boxShadow: 2,
                            maxHeight: {
                              xs: '370px',
                              sm: 'calc(70vh - 100px)'
                            },
                            overflowY: 'auto',
                            '@media (max-height: 1000px)': {
                              maxHeight: '95%',
                              overflowY: 'auto'
                            },
                            '@media (min-height: 1000px)': {
                              maxHeight: '100%'
                            }
                          }}
                          style={{ padding: '25px', }}
                        >
                          <Box
                            sx={{
                              padding: '4px',
                              backgroundColor: "#f0f0f0",
                              borderRadius: '2px',
                              textAlign: "center",
                              borderBottom: '3px dashed #000000c9'

                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "inline-block",
                                  padding: "4px 10px !important",
                                  backgroundColor: "black",
                                  borderRadius: "2px",
                                  marginBottom: 0,
                                }}
                              >
                                <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "white" }}>
                                  {currentIndex + 1}
                                </Typography>
                              </Box>

                              <Button
                                onClick={() => {
                                  if (markedForReview[currentIndex]) {
                                    handleBookmarkFalse(currentIndex);
                                  } else {
                                    handleBookmarkTrue(currentIndex);
                                  }
                                }}
                                className="MarkBtn"
                                sx={{
                                  minWidth: "auto",
                                  color: '#1976d2',
                                }}
                              >
                                {markedForReview[currentIndex] ? (
                                  <BookmarkIcon color="#1976d2" />
                                ) : (
                                  <BookmarkBorderIcon color="#1976d2" />
                                )}
                                {markedForReview[currentIndex] ? 'Marked for Review' : 'Mark for Review'}
                              </Button>
                              <Button onClick={() => handleClearResponse()} sx={{ minWidth: "auto", color: '#1976d2', lineHeight: '1.2', }} className="MarkBtn">
                                Clear response</Button>
                            </Box>
                          </Box>
                          <Typography className='questionViewer'
                            dangerouslySetInnerHTML={{ __html: currentQuestion?.question_text }}
                            sx={{
                              marginTop: '5px',
                              width: "100%",
                              textAlign: 'start',
                              fontWeight: '400',
                              fontSize: { xs: "16px", md: "18px" },
                              marginBottom: 1,
                              userSelect: 'none'
                            }}
                            onCopy={(e) => e.preventDefault()}
                            onContextMenu={(e) => e.preventDefault()}
                          />

                          {parsedOptions && parsedOptions?.map((option, index) => (
                            <Button id="optionsBtnSAT"
                              key={index}
                              variant="contained"
                              fullWidth
                              sx={{
                                marginTop: 1,
                                backgroundColor: "white",
                                color: "black",
                                justifyContent: "start",
                                border: selectedAnswers[currentIndex] === option ? "3px solid #4caf50" : "1px solid #ccc",
                                "&:hover": {
                                  backgroundColor: "#f1f1f1",
                                },
                                fontSize: { xs: "12px", md: "14px" },
                              }}
                              style={{
                                padding: '12px 20px',
                                borderRadius: '4px', fontWeight: '400'
                              }}
                              onClick={() => handleOptionSelect(option, index)}
                            >
                              <span style={{
                                border: '1px solid #aaa',
                                borderRadius: '50%',
                                padding: '7px',
                                height: '30px',
                                width: '32px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: '12px',
                              }}>{String.fromCharCode(97 + index)}</span>
                              <span dangerouslySetInnerHTML={{ __html: option }} />
                            </Button>
                          ))}
                        </Box>
                      )}
                </Grid>


              }

              <Popover
                open={Boolean(questionListAnchorEl)}
                anchorEl={questionListAnchorEl}
                onClose={handleCloseQuestionList}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                PaperProps={{
                  sx: {
                    width: '550px',
                    padding: '32px',
                    paddingTop: '20px',
                    overflowY: 'scroll',
                    overflowX: 'hidden'
                  }
                }}
              >
                <Box>
                  <Box sx={{
                    display: "flex",
                    flexWrap: 'wrap',
                    justifyContent: "space-between",
                    marginBottom: 2,
                    borderBottom: '2px solid #b1b1b1',
                    alignItems: 'baseline',
                    paddingBottom: '12px'
                  }}>

                    <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center", marginBottom: "10px" }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: "#B3B3B3", borderRadius: "4px", marginRight: 1 }} />
                      <Typography variant="body2">{"Not Answered"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: "#4caf50", borderRadius: "4px", marginRight: 1 }} />
                      <Typography variant="body2">{"Answered"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: "#2196F3", borderRadius: "4px", marginRight: 1 }} />
                      <Typography variant="body2">{"Current"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexBasis: { xs: '50%', sm: '50%', md: 'auto' }, alignItems: "center" }}>
                      <Box
                        sx={{
                          backgroundColor: '#f1f1f1',
                          width: "20px",
                          height: "20px",
                          fontWeight: "bold",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          borderRadius: '4px',
                          color: '#FFFFFF',
                          position: "relative",
                          marginRight: 1
                        }}
                      >
                        <BookmarkIcon
                          sx={{
                            position: "absolute",
                            top: "0",
                            right: "0",
                            fontSize: "16px",
                            color: "#FE780F",
                            transform: "translate(30%, -25%)",
                          }}
                        />
                      </Box>
                      <Typography variant="body2">{"Marked for Review"}</Typography>
                    </Box>
                  </Box>

                  <Grid container spacing={2}>
                    {questions && questions?.length > 0 && questions.map((q, index) => {
                      const isSelected = currentIndex === index;
                      const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, index);
                      const isMarkedForReview = markedForReview[index];

                      let backgroundColor = "#B3B3B3";
                      if (isAnswered) backgroundColor = "#4caf50";
                      if (isSelected) backgroundColor = "#2196F3";

                      return (
                        <Grid item xs={2} key={index}>
                          <Box
                            onClick={() => handleQuestionSelect(index)}
                            sx={{
                              backgroundColor,
                              width: "40px",
                              height: "40px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              borderRadius: '4px',
                              color: '#FFFFFF',
                              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                              position: "relative",
                              "&:hover": { backgroundColor: "#1976d2", color: "white" }
                            }}
                          >
                            {isMarkedForReview && (
                              <BookmarkIcon
                                sx={{
                                  position: "absolute",
                                  top: "0",
                                  right: "0",
                                  fontSize: "26px",
                                  color: "#FE780F",
                                  transform: "translate(30%, -25%)",
                                }}
                              />
                            )}
                            {index + 1}
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                  <p style={{
                    height: '5px',
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '0'
                  }}>
                    <span className="reviewBtn"
                      style={{
                        position: 'relative',

                      }}><br /></span>
                  </p>
                </Box>
              </Popover>


              <Box sx={{ backgroundColor: "#e9f0fa", display: "flex", justifyContent: "space-between", height: '60px', padding: '10px 5px !important' }}>
                <Typography sx={{ display: { xs: 'none', sx: 'none', md: 'block' } }}>{userInfo?.name}</Typography>
                <Button variant="contained" id="ViewQuestionAll" style={{ backgroundColor: "#434040", borderRadius: '4px', marginLeft: '40px' }} disabled={isPaused} onClick={handleOpenQuestionList}>
                  {"View all questions"}
                </Button>
                <Box sx={{ padding: 1, backgroundColor: "#e9f0fa", display: "flex", justifyContent: "space-between" }}>
                  <Button
                    variant="contained"
                    onClick={handleBack}
                    disabled={currentIndex === 0 || isPaused}
                    style={{
                      marginRight: '10px', background: (currentIndex === 0 || isPaused) ? '#d3d3d3' : '#1976d2',
                      borderRadius: '4px', color: "#fff"
                    }} >
                    {"Back"}
                  </Button>
                  {currentIndex === questions?.length - 1 ? (
                    <Button variant="contained" style={{ background: '#1976d2', borderRadius: '4px', color: "#fff" }} onClick={handleSubmit} disabled={isPaused} >{"Submit"}</Button>
                  ) : (
                    <Button variant="contained" style={{ background: '#1976d2', borderRadius: '4px', color: "#fff" }} onClick={() => handleNext()} disabled={isPaused}>{"Next"}</Button>
                  )}
                </Box>
              </Box>
            </Box>
          </>
        </Box>


        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ paddingBottom: '0px !important' }} sx={{ pb: 0 }} textAlign={'center'}>
            {"Do you really want to submit"}
            <Typography variant="body2" style={{ textAlign: 'center', marginBottom: '10px', fontWeight: '500', fontSize: '17px' }}>

              {"Section 1: Reading and Writing"}

            </Typography>
          </DialogTitle>
          <DialogContent style={{ borderTop: '1px solid rgb(163, 163, 163)', borderBottom: '1px solid rgb(163, 163, 163)', overflow: { sx: 'auto', sm: 'auto', md: 'hidden' } }}>

            <Box id="QuestionModulePop"
              sx={{
                margin: 'auto',

                backgroundColor: 'white',
                padding: { sx: '0px !important', sm: '10px !important', md: '20px !important' },
                paddingTop: '15px !important',
                overflow: 'hidden'

              }}
            >

              {/* <Typography variant="body2" style={{ textAlign: 'center', marginBottom: '5px', fontSize: '16px' }}><b>Module - {submodule}</b></Typography> */}

              <Box sx={{ display: "flex", flexWrap: 'wrap', justifyContent: "space-between", marginBottom: 2, borderBottom: '2px solid #b1b1b1', alignItems: 'baseline', paddingBottom: '12px !important', }}>
                <Box sx={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <Box sx={{ width: 20, height: 20, backgroundColor: "#B3B3B3", borderRadius: "4px", marginRight: 1 }} />
                  <Typography variant="body2">{"Not Answered"}</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box sx={{ width: 20, height: 20, backgroundColor: "#4caf50", borderRadius: "4px", marginRight: 1 }} />
                  <Typography variant="body2">{"Answered"}</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box sx={{ width: 20, height: 20, backgroundColor: "#2196F3", borderRadius: "4px", marginRight: 1 }} />
                  <Typography variant="body2">{"Current"}</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      backgroundColor: '#f1f1f1',
                      width: "20px",
                      height: "20px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      borderRadius: '4px',
                      color: '#FFFFFF',
                      position: "relative",
                      marginRight: 1
                    }}
                  >
                    <BookmarkIcon
                      sx={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        fontSize: "16px",
                        color: "#FE780F",
                        transform: "translate(30%, -25%)",
                      }}
                    />
                  </Box>
                  <Typography variant="body2">{"Marked for Review"}</Typography>
                </Box>
              </Box>

              <Grid container spacing={2}>
                {questions && questions?.length > 0 && questions.map((q, index) => {
                  const isSelected = currentIndex === index;
                  const isAnswered = Object.prototype.hasOwnProperty.call(selectedAnswers, index);
                  const isMarkedForReview = markedForReview[index];

                  let backgroundColor = "#B3B3B3";
                  if (isAnswered) backgroundColor = "#4caf50";
                  if (isSelected) backgroundColor = "#2196F3";

                  return (
                    <Grid item xs={2} key={index}>
                      <Box onClick={() => handleQuestionSelect(index)}

                        sx={{
                          backgroundColor,
                          width: "40px",
                          height: "40px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          borderRadius: '4px',
                          color: '#FFFFFF',
                          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                          position: "relative",
                          "&:hover": { backgroundColor: "#1976d2", color: "white" }
                        }}
                      >
                        {isMarkedForReview && (
                          <BookmarkIcon
                            sx={{
                              position: "absolute",
                              top: "0",
                              right: "0",
                              fontSize: "26px",
                              color: "#FE780F",
                              transform: "translate(30%, -25%)",
                            }}
                          />
                        )}
                        {index + 1}
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
              <p style={{
                height: '5px',
                display: 'flex',
                justifyContent: 'center',
                margin: '0'
              }}>
                <span className="reviewBtn"
                  style={{
                    position: 'relative',

                  }}><br /></span>
              </p>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box style={{ display: 'flex', justifyContent: 'space-between', flex: 2, padding: '0 20px', marginBottom: '10px' }}>
              <Button
                variant="outlined"
                onClick={() => setOpenConfirmDialog(false)}
                // color="#1976d2"
                borderColor="#1976d2"
                style={{
                  border: '1px solid #1976d2', borderRadius: '4px', color: '#1976d2',
                }}
              >
                {"Back"}
              </Button>
              <Button
                variant="outlined"
                onClick={() => handlePostUserResult()}
                //  color="#1976d2"
                style={{
                  border: '1px solid #1976d2', borderRadius: '4px', color: '#1976d2',
                }}
              >
                {"Submit"}
              </Button>
            </Box>


          </DialogActions>
        </Dialog>

        <Dialog

          open={calculatorOpen}

          onClose={handleCalculatorClose}

          PaperComponent={PaperComponent}

          aria-labelledby="draggable-calculator-dialog"

          BackdropProps={{ style: { backgroundColor: 'transparent' } }}

        >

          <DialogTitle

            className="drag-handle"

            style={{ cursor: 'move', paddingBottom: '0px' }}

          >

            <Box sx={{

              display: 'flex',

              justifyContent: 'center',

              alignItems: 'center'

            }}>

              <Typography variant="h4" color="primary" style={{ marginBottom: '8px', color: '#000' }} gutterBottom>

                Calculator

              </Typography>

              <IconButton

                onClick={handleCalculatorClose}

                size="small"

                sx={{ cursor: 'pointer', position: 'absolute', right: '8px', top: '6px' }}

              >

                <CloseIcon />

              </IconButton>

            </Box>

          </DialogTitle>

          <DialogContent sx={{ padding: '8px 2px' }}>

            <Calculator />

          </DialogContent>


        </Dialog>


        <Dialog
          open={showCongratulationsModal}
          disableEscapeKeyDown
          slotProps={{
            backdrop: {
              style: { backgroundColor: '#fff' }
            }
          }}
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center',
              minWidth: '400px'
            }
          }}
        >
          <DialogContent sx={{ padding: '20px' }}>
            <div style={{ marginTop: '0px', paddingBottom: '10px' }}>
              <div className="flex justify-center mb-4">
                <div className="relative inline-block">
                  <img style={{ justifySelf: 'center', width: '60px', marginBottom: '10px' }}
                    src={TestComplete}
                    alt="Test Complete Icon"
                    className="w-16 h-16"
                  />
                </div>
              </div>

              <h2 className="text-xl font-bold text-blue-600" id="canvas" style={{
                textAlign: 'center',
                marginTop: '5px', fontWeight: '700', color: "#6c98fd !important"
              }}>Congratulations!</h2>
              <p className="text-gray-600 mt-2" style={{
                textAlign: 'center', marginTop: '10px'
              }}>
                You have successfully completed the Test.
              </p>

            </div>

            <LottieLoading />
          </DialogContent>
        </Dialog>
      </>
      }
    </Box>
  );
}
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#002b50',
  borderRadius: '4px',
  padding: '2px 10px',
  textAlign: 'center',
  color: "#fff",
  fontSize: '14px'
}));

const useStyles = makeStyles(() => ({
  greetingCard: {
    width: '100%',
    backgroundColor: '#d2daff',
    borderRadius: '18px',
  }

})); 